<template>
	<div>
		<el-row>
			<el-col :span="24" class="bread">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item>物种详情管理</el-breadcrumb-item>
				</el-breadcrumb>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="24">
				<crud :fields="fields" :select="select" :limits="limits" apiU="Speciesdetails"></crud>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				fields: [
					{
						name: 'name',
						label: '名称',
						type: 'string',
						isphone: true,
						rule: [
							{ required: true, message: '请输入名称', trigger: 'blur' }
						]
					},
					{
						name: 'type',
						label: '类型',
						type: 'select',
						data: [
							{
								label: "动物",
								value: "animal"
							},
							{
								label: "植物",
								value: "plant"
							}
						],
						prop: {
							label: "label",
							value: "value"
						},
						isphone: true,
						rule: [
							{ required: true, message: '请选择类型', trigger: 'blur' }
						]
					},
					{
						name: 'colour',
						label: '颜色',
						type: 'string',
						isphone: true,
						rule: [
							{ required: true, message: '请输入颜色', trigger: 'blur' }
						]
					},
					{
						name: 'subsist',
						label: '生活类型',
						type: 'select',
						data: [
							{
								label: "水",
								value: "water"
							},
							{
								label: "陆",
								value: "land"
							},
							{
								label: "空",
								value: "air"
							}
						],
						prop: {
							label: "label",
							value: "value"
						},
						isphone: true,
						rule: [
							{ required: true, message: '请选择生活类型', trigger: 'blur' }
						]
					},
					{
						name: 'trait',
						label: '特征',
						type: 'text',
						isphone: true,
						rule: [
							{ required: true, message: '请输入特征', trigger: 'blur' }
						]
					},
					{
						name: 'variety',
						label: '品种',
						type: 'string',
						isphone: true,
						rule: [
							{ required: true, message: '请输入品种', trigger: 'blur' }
						]
					},
					{
						name: 'image',
						label: '图片',
						type: 'image',
						isphone: true,
						rule: [
							{ required: true, message: '请上传图片', trigger: 'blur' }
						]
					},
					{
						name: 'images',
						label: '更多图片',
						type: 'images',
						isphone: true,
						rule: [
							{ required: true, message: '请上传更多图片', trigger: 'blur' }
						]
					},
					{
						name: 'facade',
						label: '外观',
						type: 'text',
						isphone: true,
						rule: [
							{ required: true, message: '请输入外观', trigger: 'blur' }
						]
					},
					{
						name: 'taste',
						label: '口感',
						type: 'text',
						isphone: true,
						rule: [
							{ required: true, message: '请输入口感', trigger: 'blur' }
						]
					},
					{
						name: 'weightMax',
						label: '最大重量',
						type: 'string',
						isphone: true,
						rule: [
							{ required: true, message: '请输入最大重量', trigger: 'blur' }
						]
					},
					{
						name: 'weightCommon',
						label: '成年重量',
						type: 'string', 
						isphone: true,
						rule: []
					},
					{
						name: 'tasteMin',
						label: '最小重量',
						type: 'string',
						isphone: true,
						rule: [
							{ required: true, message: '请输入最小重量', trigger: 'blur' }
						]
					},
					{
						name: 'unit',
						label: '单位',
						type: 'string',
						isphone: true,
						rule: [
							{ required: true, message: '请输入单位', trigger: 'blur' }
						]
					},
					{
						name: 'nutrition',
						label: '营养成分',
						type: 'text',
						isphone: true,
						rule: [
							{ required: true, message: '请输入营养成分', trigger: 'blur' }
						]
					},
					{
						name: 'temperature',
						label: '适宜温度',
						type: 'string',
						isphone: true,
						rule: [
							{ required: true, message: '请输入适宜生存温度', trigger: 'blur' }
						]
					},
					{
						name: 'humidity',
						label: '适宜湿度',
						type: 'string',
						isphone: true,
						rule: [
							{ required: true, message: '请输入适宜生存湿度', trigger: 'blur' }
						]
					},
					{
						name: 'survival',
						label: '生存方式',
						type: 'text',
						isphone: true,
						rule: [
							{ required: true, message: '请输入适宜生存方式', trigger: 'blur' }
						]
					},
					{
						name: 'ph',
						label: '适宜PH',
						type: 'string',
						isphone: true,
						rule: []
					},
					{
						name: 'life',
						label: '生命周期',
						type: 'text',
						isphone: true,
						rule: []
					},
					{
						name: 'description',
						label: '描述',
						type: 'text',
						isphone: true,
						rule: [
							{ required: true, message: '请输入描述', trigger: 'blur' }
						]
					},
					{
						name: 'content',
						label: '内容',
						type: 'text',
						isphone: true,
						rule: [
							{ required: true, message: '请输入内容', trigger: 'blur' }
						]
					}
				],
				select: [],
				limits: {
					add: true,
					delete: true,
					edit: true,
					find: true,
					export: true,
					look: true
				}
			}
		},
		methods: {
			
		},
		filters: {
			
		},
		mounted: function () {
			
		},
		computed: {
			
		}
	}
</script>

<style scoped>
	.bread{
		margin: 15px 0px;
	}
	@media screen and (min-width: 0px) and (max-width: 700px){
		.bread{
			margin: 5px 0px;
		}
	}
</style>
